/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Realitni_EsoInputs */

const cs_enum_realitni_eso = /** @type {(inputs: Enum_Realitni_EsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní ESO`)
};

const en_enum_realitni_eso = /** @type {(inputs: Enum_Realitni_EsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní ESO`)
};

/**
* | output |
* | --- |
* | "Realitní ESO" |
*
* @param {Enum_Realitni_EsoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitni_eso = /** @type {((inputs?: Enum_Realitni_EsoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Realitni_EsoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitni_eso(inputs)
	return cs_enum_realitni_eso(inputs)
});